import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ReduxState } from 'redux/types';

import { Props as KpiTableProps } from '../../KpiTable';
import NoteAddMonthCell from './components/NoteAddMonthCell/NoteAddMonthCell';
import { LeftBorderTableCell, NoWrapTableCell } from './styled';

interface Props extends Pick<KpiTableProps, 'months' | 'canAddNewMonth' | 'addMonth'> {
    setRefFirstColumn: (node: any) => void;
    firstColumnStyle: React.CSSProperties;
    secondColumnStyle: React.CSSProperties;
}

const KpiTableHeader = (props: Props) => {
    const { months, canAddNewMonth, addMonth, setRefFirstColumn, firstColumnStyle, secondColumnStyle } = props;

    const { type: userType } = useSelector((state: ReduxState) => state.user);

    const { t } = useTranslation();

    return (
        <TableHead>
            <TableRow>
                <TableCell ref={setRefFirstColumn} style={{ ...firstColumnStyle, fontWeight: '500' }}>#</TableCell>

                <LeftBorderTableCell style={{ ...secondColumnStyle, fontWeight: '500' }}>
                    {t('pages.plastic_assessment.tabs.kpi.table.description')}
                </LeftBorderTableCell>

                <LeftBorderTableCell style={{ whiteSpace: 'nowrap', fontWeight: '500' }}>
                    {t('pages.plastic_assessment.tabs.kpi.table.stock')}
                </LeftBorderTableCell>

                <NoteAddMonthCell canAddNewMonth={canAddNewMonth} addMonth={addMonth} />

                {months.map((m: any) => {
                    return (
                        <LeftBorderTableCell style={{ fontWeight: '500' }}>{m.month}/{m.year}</LeftBorderTableCell>
                    );
                })}

                <NoWrapTableCell style={{ fontWeight: '500' }}>{t('pages.plastic_assessment.tabs.kpi.table.average_consume')}</NoWrapTableCell>
                <NoWrapTableCell style={{ fontWeight: '500' }}>{t('pages.plastic_assessment.tabs.kpi.table.last_month_consume')}</NoWrapTableCell>
                <NoWrapTableCell style={{ fontWeight: '500' }}>{t('pages.plastic_assessment.tabs.kpi.table.year')}</NoWrapTableCell>

                {['admin', 'auditor'].includes(userType) && (
                    <>
                        <NoWrapTableCell style={{ fontWeight: '500' }}>{t('pages.plastic_assessment.tabs.kpi.table.co2_saved')}</NoWrapTableCell>
                        <NoWrapTableCell style={{ fontWeight: '500' }}>{t('pages.plastic_assessment.tabs.kpi.table.state')}</NoWrapTableCell>
                    </>
                )}
            </TableRow>
        </TableHead>
    );
};

export default KpiTableHeader;